/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';

export const arSummaryQtrData = (val) => {
  return { type: actiontypes.AR_SUMMARY_QTR_TABLE, payload: val };
};
export const unallocatedBalanceQtrData = (data) => ({
  type: actiontypes.AR_SUMMARY_UNALLOCATED_QTR_TABLE,
  getUnallocatedBlnQtrList: data,
});
export const singleAccRecQtrData = (data) => ({
  type: actiontypes.AR_SUMMARY_SINGLE_QTR_TABLE,
  getSingleAccRecQtrList: data,
});
export const quarterValue = (data) => ({
  type: actiontypes.AR_SUMMARY_SINGLE_QTR_VALUE,
  getQuarterValue: data,
});
export const arSummartyByQTRFieldSingle = (val) => {
  return { type: actiontypes.SINGLE_FLD_DATA, payload: val };
};
export const getUnallocatedBalanceQtr = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_UNALLOCATED_BALANCE_QTR}`, val)
    .then((response) => {
      dispatch(unallocatedBalanceQtrData(response.data));
    })
    .catch(() => {
      dispatch(unallocatedBalanceQtrData([]));
    });
};
export const getSingleAccRecQtr = (val) => (dispatch) => {
  let accRecQtrval = {
    [val.rebateProgram]: val.quarter,
  };
  dispatch(quarterValue(accRecQtrval));
  return axios
    .post(`${serviceEndPoint.GET_AR_QTR_SINGLE}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.AR_SMRY_FOR_QTR_SINGLE,
        payload: response.data,
      });
      let accRecData = {
        [val.rebateProgram]: response.data,
      };
      dispatch(singleAccRecQtrData(accRecData));
    })
    .catch(() => {
      dispatch(singleAccRecQtrData([]));
      dispatch({
        type: actiontypes.AR_SMRY_FOR_QTR_SINGLE,
        payload: null,
      });
    });
};

export const dispatchClearARSummaryByQtrData = (val) => {
  return { type: actiontypes.AR_SUMMERY_QTR_FIELD_CLEAR_REDUX, payload: val };
};

export const clearARSummaryByQtrPage = (history) => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.ArSummaryQtrReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let changePass = false;
  let nObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    if (
      updateTabs.filter(
        (x) => x.navTo === '/QtrAccountsRec' || x.navTo === '/QtrAccountsRecAll'
      ).length === 0
    ) {
      nObj1 = {};
      changePass = true;
    }
    if (updateTabs.filter((x) => x.navTo === '/QtrAccountsRec').length !== 0) {
      nObj1.ar_smry_single_qtr = reduxObj.ar_smry_single_qtr || {};
      nObj1.getQuarterValue = reduxObj.getQuarterValue || null;
    }
    if (
      updateTabs.filter((x) => x.navTo === '/QtrAccountsRecAll').length !== 0
    ) {
      nObj1.ar_smry_single_qtr_main = reduxObj.ar_smry_single_qtr_main;
    }
  } else {
    changePass = true;
    nObj1 = {};
  }
  dispatch(dispatchClearARSummaryByQtrData(nObj1));
};
